export const ADD_ARR_FLASH_CARD_REQUEST =
  "ADD_ARR_FLASH_CARD_REQUEST";
export const ADD_ARR_FLASH_CARD_RESPONSE =
  "ADD_ARR_FLASH_CARD_RESPONSE";
export const GET_ALL_FLASH_CARD_REQUEST =
  "GET_ALL_FLASH_CARD_REQUEST";
export const GET_ALL_FLASH_CARD_RESPONSE =
  "GET_ALL_FLASH_CARD_RESPONSE";
export const GET_SINGLE_FLASH_CARD_REQUEST =
  "GET_SINGLE_FLASH_CARD_REQUEST";
export const GET_SINGLE_FLASH_CARD_RESPONSE =
  "GET_SINGLE_FLASH_CARD_RESPONSE";
export const EDIT_SINGLE_FLASH_CARD_REQUEST =
  "EDIT_SINGLE_FLASH_CARD_REQUEST";
export const DELETE_SINGLE_FLASH_CARD_REQUEST =
  "DELETE_SINGLE_FLASH_CARD_REQUEST";
export const DELETE_SINGLE_FLASH_CARD_RESPONSE =
  "DELETE_SINGLE_FLASH_CARD_RESPONSE";

export const SET_FLASH_CARD_SEARCH = "SET_FLASH_CARD_SEARCH";
export const SET_FLASH_CARD_PAGE = "SET_FLASH_CARD_PAGE";
